export const MODAL_SIZE_MINI = 'mini';
export const MODAL_SIZE_TINY = 'tiny';
export const MODAL_SIZE_SMALL = 'small';
export const MODAL_SIZE_LARGE = 'large';
export const MODAL_SIZE_FULLSCREEN = 'fullscreen';
export const MODAL_LOADING_CONFIRMATION_BUTTON = 'confirmationButtonLoading';
export const MODAL_LOADING_ICON = 'iconLoading';
export const GENERAL_CONFIRM_BUTTON = 'general.button.ok';
export const GENERAL_CANCEL_BUTTON = 'general.button.cancel';
